import "./PenaltyButton.css";
import config from "./appconf";

interface PenaltyButtonInfo {
  marked: boolean;
  disabled: boolean;
  size: string;
}

function PenaltyButton({ marked, disabled, size }: PenaltyButtonInfo) {
  const handleClick = () => {
    fetch(`${config.baseUrl}/api/v1/markBox`, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ color: "penalty", number: 0 }),
    })
      .then((res) => {
        console.log(`Tried to mark box and got a response of ${res.status}`);
      })
      .catch((err) => {
        console.log(`Failed to POST to markBox. error=${err}`);
      });
  };
  return (
    <button
      className={`penaltyButton ${size}`}
      disabled={disabled}
      onClick={handleClick}
    >
      {marked ? "X" : ""}
    </button>
  );
}

export default PenaltyButton;
